import { useState, useEffect } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

function TimedAlert({ alert }) {
  const { status, message, open, duration, position, timestamp } = alert;
  const alertPosition = position ? position : { vertical: 'top', horizontal: 'center' };
  var alertDuration;
  if (typeof duration === 'undefined') {
    // If no duration was given, use:
    // - Unlimited for an error or critical
    // - 6 seconds for other message types
    alertDuration = (status == 'error' || status == 'critical' ? null : 6000);
  } else {
    // Use user-requested expiry duration
    alertDuration = (duration <= 0 ? null : duration);
  }

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsOpen(open);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timestamp]);

  function handleClose(_event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    setIsOpen(false);
  }

  const severity = status === 'critical' ? 'error' : status;
  const variant = status === 'critical' ? 'filled' : 'standard';

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={alertDuration}
      onClose={handleClose}
      anchorOrigin={alertPosition}
      key={timestamp}
    >
      <Alert onClose={handleClose} severity={severity} variant={variant}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default TimedAlert;
